import NutanixIcon from '@liquidweb-dev/undercurrent/icons/platform/Nutanix';
import Label from 'components/ServersList/ServerDetails/Label';
import Location from 'components/ServersList/ServerDetails/ServerDetailsLocation';
import ServerListDetailBox from 'components/ServersList/ServersListDetailBox';
import type { AssetDetails } from 'modules/queries/asset/useDetails';

export interface NutanixDetailsProps {
	assetDetails: AssetDetails;
}

/**
 * Service metadata shown for a Nutanix Private Cloud asset in the server list —
 * product type and location. Nutanix assets deliberately omit the OS, control
 * panel, management level, backups, and security details other server types
 * show. Prism is reached from the actions menu and the detail page.
 */
const NutanixDetails = ({ assetDetails }: NutanixDetailsProps) => {
	const { country, location } = assetDetails;

	return (
		<>
			<ServerListDetailBox sx={{ minWidth: '40px' }}>
				<NutanixIcon
					sx={({ size }) => ({
						height: size.xS,
						width: size.xS,
						flexShrink: 0,
					})}
				/>
				<Label>Nutanix</Label>
			</ServerListDetailBox>

			<ServerListDetailBox sx={{ minWidth: (theme) => theme.size.xS }}>
				<Location location={location || ''} country={country || ''} />
			</ServerListDetailBox>
		</>
	);
};

export default NutanixDetails;
